/**
 * El símbolo de cada rol de proyecto.
 *
 * Vive aquí y no en `@webbuilder/shared-types` a propósito: ese paquete lo
 * importa también el worker, y meterle componentes de React lo ataría a una
 * dependencia que allí no pinta nada. El catálogo aporta el TONO y la etiqueta,
 * que son datos; el dibujo lo pone el panel.
 *
 * Y aquí y no dentro de una pantalla porque ya lo usan tres —el catálogo de
 * roles en Equipo, la tarjeta de proyecto del menú y la lista de proyectos—: con
 * una copia por sitio, añadir un rol dejaría dos de ellas con un hueco.
 *
 * Los símbolos son los mismos que llevan sus secciones en el menú lateral —el
 * cilindro de Contenido, el lápiz de edición— para que el rol y lo que abre se
 * reconozcan a la vez. El dueño lleva corona: no es un rol del catálogo, es de
 * quien está el proyecto a su nombre, y merece un símbolo que no se confunda con
 * los demás.
 */
import {
  IconCoin,
  IconCrown,
  IconDatabase,
  IconEye,
  IconPalette,
  IconPencil,
  IconShieldLock,
} from '@tabler/icons-react'
import type { ProjectAccessRole, ProjectRole } from '@webbuilder/shared-types'

export const ROLE_ICONS: Record<ProjectRole, typeof IconShieldLock> = {
  admin: IconShieldLock,
  editor: IconPencil,
  design: IconPalette,
  content: IconDatabase,
  finance: IconCoin,
  viewer: IconEye,
}

/** El del dueño incluido. */
export function roleIcon(role: ProjectAccessRole): typeof IconShieldLock {
  return role === 'owner' ? IconCrown : ROLE_ICONS[role]
}
